<template>
<w-settings-summary ref="settingsSummary" :menu="menu" @change="onChangeMenu">
  <component slot="activeView" :is="activeView" :title="activeMenu.name"></component>
</w-settings-summary>
</template>

<script>
import findIndex from 'lodash/findIndex';
import isEmpty from 'lodash/isEmpty';
import summaryApi from '@/api/settings/settings-summary';
import { getValueAfterCheckEmpty } from '@/utils/string';
import WSettingsSummary from '@/components/template/SettingsSummary';
import WSavedQuery from './SavedQuery';

export default {
  name: 'WDatabaseSettings',
  components: {
    WSettingsSummary,
    WSavedQuery,
  },
  data() {
    return {
      activeMenu: {},
      activeView: null,
      menu: [
        {
          id: 'savedQuery',
          name: '저장 쿼리문',
          desc: ['사용자 쿼리를 벤더별로 저장합니다.', '저장된 쿼리는 쿼리수행기를 통해 즉시 실행할 수 있습니다.'],
          data: null,
          orderbyIndex: 1,
        },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    onChangeMenu(activeView, activeMenu) {
      this.activeView = activeView;
      this.activeMenu = activeMenu;
    },
    clearActiveView() {
      this.$refs.settingsSummary.clearActiveView();
      this.loadData();
    },
    loadData() {
      summaryApi.getDatabaseSettingsSummaryCount().then((response) => {
        const result = response.data;
        if (result.success === true && !isEmpty(result.data)) {
          const data = result.data;
          const savedQuerySettingsData = [`현재 등록된 사용자 쿼리문은 <em>${getValueAfterCheckEmpty(data.savedQueryCount)}개</em> 입니다.`];
          const savedQuerySettingsIndex = findIndex(this.menu, (item) => item.id === 'savedQuery');
          this.menu[savedQuerySettingsIndex].data = savedQuerySettingsData;
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/database/index.vue